// extracted by mini-css-extract-plugin
module.exports = {"calories":"QSRCalories_calories__CuNTt","caloriesIcon":"QSRCalories_caloriesIcon__CqCEq","label":"QSRCalories_label__0rYSb","v2":"QSRCalories_v2__Jd_K_"};